import { CustomerChangeRequestSelectSchema } from "@norskgassnett/db";
import { z } from "zod";
import { StatusOk } from "../_core.js";
import { UpdateCompanyCustomerRequestBody } from "../business_central.js";
export const StartUpdateCustomerFlowRequestBody = z
    .object({
    id: z.string(),
    email: UpdateCompanyCustomerRequestBody.shape.email.transform((val) => val ? val.toLocaleLowerCase() : undefined),
    phoneNumber: UpdateCompanyCustomerRequestBody.shape.formasjonPhoneNo,
})
    .meta({ ref: "StartUpdateCustomerFlowRequestBody" });
export const StartUpdateCustomerFlowResponseBody = StatusOk.meta({
    ref: "StartUpdateCustomerFlowResponseBody",
});
export const CompleteUpdateCustomerFlowRequestBody = z
    .object({
    id: CustomerChangeRequestSelectSchema.shape.bcId,
    code: CustomerChangeRequestSelectSchema.shape.code,
    property: CustomerChangeRequestSelectSchema.shape.property,
})
    .meta({ ref: "CompleteUpdateCustomerFlowRequestBody" });
export const CompleteUpdateCustomerFlowResponseBody = StatusOk.meta({
    ref: "CompleteUpdateCustomerFlowResponseBody",
});
export const RelocateCustomerRequestBody = z
    .object({
    meterReading: z.coerce.number().nonnegative(),
    relocationDate: z.coerce.date(),
    invoiceAddress: z.string().min(1),
    postalCode: z.string().min(1),
    place: z.string().min(1),
    newOwnerName: z.string().min(1),
    newOwnerBirthdate: z.coerce.date(),
    newOwnerTlf: z.e164(),
    newOwnerEmail: z.email().toLowerCase(),
    newOwnerAddress: z.string().optional(),
    newOwnerPostalCode: z.string().optional(),
    newOwnerPlace: z.string().optional(),
    newOwnerIsAware: z.boolean(),
})
    .meta({ ref: "RelocateCustomerRequestBody" });
export const RelocateCustomerResponseBody = StatusOk.meta({
    ref: "RelocateCustomerResponseBody",
});
